import { fireworkScore } from "../celebration/fireworkScore";

const clamp = (n: number) => Math.min(1, Math.max(0, n));
const smooth = (a: number, b: number, n: number) => {
  const t = clamp((n - a) / (b - a));
  return t * t * (3 - 2 * t);
};

/** Shared with the CSS fallback. Chapter weights follow the authored scroll,
 * never DOM offsets, so reversing the page also reverses the environment. */
export function getEnvironmentMood(progress: number, storyActive: boolean, celebration: number) {
  const p = storyActive ? clamp(progress) : 0;
  const night = clamp(celebration);
  const garden = smooth(0.36, 0.46, p) * (1 - smooth(0.65, 0.76, p)) * (1 - night);
  const supper = smooth(0.67, 0.8, p) * (1 - night);
  return {
    garden,
    supper,
    moon: 1 - garden * 0.52 - supper * 0.68,
    water: 1 - garden * 0.6 - supper * 0.8,
    galaxy: (0.3 + smooth(0.06, 0.18, p) * 0.7) * (1 - garden * 0.7) * (1 - supper) * (1 - night * 0.82),
  };
}

export function getReflectedShells(elapsed: number, compact: boolean, aspect: number) {
  return fireworkScore.filter(cue => elapsed >= cue.at && elapsed < cue.at + cue.life)
    .slice(-3).map(cue => {
      const age = elapsed - cue.at;
      const halfWidth = Math.tan(24 * Math.PI / 180) * (5 - cue.z) * Math.max(0.2, aspect);
      return {
        x: 0.5 + cue.x * (compact ? 0.32 : 1) / (halfWidth * 2),
        age,
        power: cue.power * smooth(0, 0.16, age) * (1 - smooth(cue.life * 0.3, cue.life, age)),
        palette: cue.palette,
      };
    });
}

// The existing celebration timeline owns this clock. No additional RAF or timer.
export const environmentPlayback = { elapsed: -1 };
